import AdsError from './AdsError.js'

export default class GetSearchDataFromUrlError extends AdsError {}
